import { z } from 'zod'

// Shared password-complexity rules — every flow that lets a user set a new
// password (change password, self-service reset, admin-driven reset) must
// enforce the same minimum length + character-class requirements so the
// checks and their translated messages never drift apart.
export const PASSWORD_MIN_LENGTH = 8
export const PASSWORD_UPPERCASE_PATTERN = /[A-Z]/
export const PASSWORD_LOWERCASE_PATTERN = /[a-z]/
export const PASSWORD_NUMBER_PATTERN = /\d/
export const PASSWORD_SPECIAL_CHAR_PATTERN = /[!@#$%^&*(),.?":{}|<>]/

export const getPasswordComplexitySchema = (t: (key: string) => string) =>
  z
    .string()
    .min(PASSWORD_MIN_LENGTH, t('changePassword.req8Chars'))
    .regex(PASSWORD_UPPERCASE_PATTERN, t('changePassword.reqUppercase'))
    .regex(PASSWORD_LOWERCASE_PATTERN, t('changePassword.reqLowercase'))
    .regex(PASSWORD_NUMBER_PATTERN, t('changePassword.reqNumber'))
    .regex(PASSWORD_SPECIAL_CHAR_PATTERN, t('changePassword.reqSpecial'))
